<div class="glow-container">
    <ng-content></ng-content>
  </div>
  